/* eslint-disable no-shadow */
import Vue from 'vue';
import {
  SET_STEPS,
  FETCH_STEPS,
  SET_ALLOW_SHOW, SET_ELEMENT, SET_TITLE,
} from '@/store/actions/onBoarding';

/**
 * @description Хранилище Онбординга
 * @type {string}
 */

const state = {
  steps: [],
  title: '',
  allowShow: false,
  elements: [],
};

const getters = {
  getSteps: (state) => state.steps,
  getTitle: (state) => state.title,
  getAllowToShow: (state) => state.allowShow,
  getStepBySlug: (state) => (slug) => state.steps.find((step) => step.slug === slug) ?? null,
  getElementByKey: (state) => (keyOfElement) => state.elements[keyOfElement],
  getElements: (state) => state.elements,
};
const methods = {
  /**
   * Определить "Якорь" шага
   *
   * @param slug {string}
   * @return {string}
   */
  defineAnchorLink(slug) {
    switch (slug) {
      case 'data-of-clinic':
        return '/settings';
      case 'create-addition-place':
        return '/cabinets';
      case 'meet-with-allowed-roles':
        return '/roles';
      case 'view-schedule':
        return '/appointment-settings';
      case 'insert-data-about-employers':
        return '/employees';
      case 'insert-schedule-work':
        return '/work-schedule';
      case 'insert-price-in-price-list':
        return '/price-list';
      default:
        return '/';
    }
  },
};

const actions = {
  [FETCH_STEPS]: ({ commit }) => Vue
    .axios
    .get('api/onboarding/steps')
    .then(
      async (response) => {
        const allowShow = response.data.allow_show_on_boarding;
        const items = (response.data.data || []).map((item) => ({
          name: item.name,
          isPassed: item.is_passed,
          id: item.id,
          linkAnchor: methods.defineAnchorLink(item.slug),
          slug: item.slug,
          notShowedView: item.not_showed_view,
          isAccess: item.is_access,
          isHide: item.is_hide,
        }));
        const { title } = response.data;
        commit(SET_STEPS, items);
        commit(SET_TITLE, title);
        commit(SET_ALLOW_SHOW, allowShow);
      },
    ),
};

const mutations = {
  [SET_STEPS]: (state, steps) => {
    state.steps = steps;
  },
  [SET_TITLE]: (state, title) => {
    state.title = title;
  },
  [SET_ALLOW_SHOW]: (state, allow) => {
    state.allowShow = allow;
  },
  [SET_ELEMENT]: (state, key, element = {}) => {
    state.elements.push(element);
  },
};

export default () => ({
  state,
  getters,
  actions,
  mutations,
});
